import React from "react";
import { Database, Calendar, MapPin } from "lucide-react";

// Function to generate filters configuration with translation
export const getFiltersConfig = (translate, getDynamicFilters) => [
  {
    topFilters: [
      {
        components: [
          {
            name: translate("in-transit-list.filters.onlyCritical"),
            type: "switch",
            key: "IsInTransitCritical",
            filterType: "boolean",
            operator: "EQ",
          },
        ],
      },
    ],
    mainFilters: [
      {
        key: "ReconciliationStreamName",
        displayName: translate("in-transit-list.filters.stream"),
        icon: () => <Database size={18} />,
        components: [
          {
            name: translate("in-transit-list.filters.stream"),
            type: "title",
            key: "title",
          },
          {
            name: translate("in-transit-list.filters.reconciliationRunId"),
            type: "numberInput",
            key: "ReconciliationRunId",
            placeHolder: translate("shared.filterRunID"),
            decimalPoint: 0,
            step: 1,
            operator: "EQ",
            filterType: "string",
            hasDecimal: false,
          },
          {
            name: translate("in-transit-list.filters.recordReference"),
            type: "searchInput",
            key: "RecordReference",
            filterType: "string",
            operator: "EQ",
          },
          {
            name: translate("in-transit-list.filters.amount"),
            type: "numberInput",
            key: "Amount",
            filterType: "amount",
            inputType: "number",
          },
          {
            name: translate("in-transit-list.filters.reconciliationStreamName"),
            type: "checkboxGroup",
            key: "ReconciliationStreamTag",
            values: getDynamicFilters("ReconciliationStreamTag"),
            filterType: "checkbox",
            operator: "EQ",
          },
        ],
      },
      {
        key: "Location",
        displayName: translate("in-transit-list.filters.location"),
        icon: () => <MapPin size={18} />,
        components: [
          {
            name: translate("in-transit-list.filters.location"),
            type: "title",
            key: "title",
          },
          {
            name: translate("in-transit-list.filters.area"),
            type: "checkboxGroup",
            key: "AreaId",
            values: getDynamicFilters("AreaId"),
            filterType: "checkbox",
            operator: "EQ",
            searchable: false,
          },
          {
            name: translate("in-transit-list.filters.outlet"),
            type: "checkboxGroup",
            key: "OutletId",
            values: getDynamicFilters("OutletId"),
            filterType: "checkbox",
            operator: "EQ",
          },
          {
            name: translate("in-transit-list.filters.terminal"),
            type: "checkboxGroup",
            key: "TransactionTerminalCode",
            values: getDynamicFilters("TransactionTerminalCode"),
            filterType: "checkbox",
            operator: "EQ",
          },
        ],
      },
      {
        key: "NextReconciliationRun",
        displayName: translate("in-transit-list.filters.date"),
        icon: () => <Calendar size={18} />,
        components: [
          {
            name: translate("in-transit-list.filters.selectDate"),
            type: "title",
            key: "title",
          },
          {
            name: translate("in-transit-list.filters.RecordDate"),
            type: "dateInput",
            inputType: "date",
            key: "RecordDate",
            placeHolder: translate("in-transit-list.filters.RecordDate"),
            prefix: "",
            filterType: "date",
          },
          {
            name: translate("in-transit-list.filters.businessDay"),
            type: "dateInput",
            inputType: "date",
            key: "BusinessDay",
            placeHolder: translate("in-transit-list.filters.businessDay"),
            prefix: "",
            filterType: "date",
          },
          {
            name: translate("in-transit-list.filters.DeadlineDate"),
            type: "dateInput",
            inputType: "date",
            key: "InTransitDeadline",
            placeHolder: translate("in-transit-list.filters.DeadlineDate"),
            prefix: "",
            filterType: "date",
          },
        ],
      },
    ],
  },
];

// Filter display values configuration
export const getFilterDisplayValues = (translate) => ({
  trigger: [
    {
      displayName: translate("filters-display.Manual"),
      value: "Manual",
    },
    {
      displayName: translate("filters-display.Schedule"),
      value: "Schedule",
    },
  ],
});

// Selected filters display configuration
export const getSelectedFiltersDisplay = (translate) => ({
  direction: translate("filters-display.Direction"),
  ReconciliationStreamTag: translate("filters-display.StreamName"),
  TotalInTransitRecords: translate("filters-display.InTransitRecordID"),
  TotalExceptionRecords: translate("filters-display.ExceptionRecordID"),
  TotalMatchingRecords: translate("filters-display.MatchingRecordID"),
  TotalReconciledRecords: translate("filters-display.ReconciledRecordID"),
  NextReconciliationRun: translate("filters-display.NextRun"),
  StartDate: translate("filters-display.StartDate"),
  EndDate: translate("filters-display.EndDate"),
  ScheduleDate: translate("filters-display.ScheduleDate"),
  contains: translate("filters-display.Contains"),
  startWith: translate("filters-display.StartsWith"),
  endWith: translate("filters-display.EndsWith"),
  IsScheduled: translate("filters-display.Scheduled"),
  ReconciliationRunStatusTag: translate("filters-display.StreamStatus"),
  Trigger: translate("filters-display.Trigger"),
  RunID: translate("filters-display.RunID"),
  BusinessDay: translate("filters-display.BusinessDay"),
  AreaId: translate("filters-display.Area"),
  OutletId: translate("filters-display.Outlet"),
  TransactionTerminalCode: translate("filters-display.Terminal"),
  RecordReference: translate("filters-display.RecordReference"),
  RecordDate: translate("filters-display.RecordDate"),
  ReconciliationRunId: translate("filters-display.RunID"),
  IsInTransitCritical: translate("filters-display.OnlyCriticalRecords"),
  InTransitDeadline: translate("filters-display.DeadlineDate"),
});
